import { render, staticRenderFns } from "./bankInfo.vue?vue&type=template&id=7c155f6a&scoped=true"
import script from "./bankInfo.vue?vue&type=script&lang=js"
export * from "./bankInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c155f6a",
  null
  
)

export default component.exports